var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8074 8.80346V15.7349L1.9336 19.2975C1.45303 21.2569 1.05614 22.8817 1.0516 22.9081C1.04534 22.9448 1.0547 22.9541 1.0914 22.9478C1.1178 22.9433 2.74214 22.5464 4.70104 22.0658L8.26269 21.1921H15.195H22.1274V11.5321V1.87207H12.4674H2.8074V8.80346ZM4.31923 9.64207L4.31904 15.9001L3.70701 18.3939C3.37041 19.7655 3.09873 20.8914 3.10332 20.896C3.10788 20.9005 4.23386 20.6288 5.60551 20.2922L8.0994 19.6801H14.3574H20.6154V11.5321V3.38407H12.4674H4.3194L4.31923 9.64207ZM8.25539 9.18007V9.93607H12.4674H16.6794V9.18007V8.42407H12.4674H8.25539V9.18007ZM8.25539 13.8841V14.6401H11.5314H14.8074V13.8841V13.1281H11.5314H8.25539V13.8841Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.96367b8b.svg";
export { ForwardRef as ReactComponent };